import { Card, Col, Collapse, Divider, Form, Row, message, Result, Descriptions, Alert, Skeleton, Button } from "antd";
import React, { useEffect, useState } from "react";
import { easyCollectAPI } from "../../services/api/";
import SmartPayError from "../error";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import "./index.css"
import { HeaderComponent } from "../../shared_components";
import { BASE_CONFIG } from '../../pages/easycollect/config'

const PaymentForm = {
    "bank_account_number": { label: "TPV Account Number", formatter: (v) => v && v },
    "account_ifsc": { label: "TPV Account IFSC", formatter: (v) => v && v }
}

const RemotePrePayment = (await import("../../reactAdapter")).EasycollectPrePaymentApp

const RemotePostPayment = (await import("../../reactAdapter")).EasycollectPostPaymentApp

const PaymentInfoFields = {
    "firstname": { label: "First Name", key: '' },
    "email": { label: "Email", key: '' },
    "phone": { label: "Phone", key: '' },
    "status": {
        'label': "Payment Status",
        'key': 'payment_details',
        'valuemapper': {
            "success": "Success",
            'user_cancelled': "User Cancelled",
            'failed': 'Failure',
            'initiated': 'Initiated',
            'pending': 'Pending',
            'processing': 'Processing',
            'expired': 'Expired',
            'dropped': 'Dropped',
            'bounced': 'Bounced',
            'authorized': "Authorized",
            "requested": 'Requested',
            'revoked': 'Revoked',
            'paused': 'Paused',
            'cancelled': 'Cancelled',
            'rejected': 'Rejected',
            'cancelling': 'Cancelling',
        }
    },
    "easepayid": { 'label': "Easebuzz ID", 'key': 'payment_details' },
    'error_Message': { 'label': "Error Message", 'key': 'payment_details' },
    "amount": { label: "Amount", key: '' },
}

const EasyCollect = (props) => {
    const { propsLinkData = {} } = props
    const [linkData, setlinkData] = useState({})
    const [validatedAmount, setValidatedAmount] = useState(0)
    const [isPaymentRequestInitiated, setPaymentRequest] = useState(false)
    const [valid_transaction, setValidTransaction] = useState(true)
    const [error, setError] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [errorDetails, setErrorDetails] = useState({})
    const [form] = Form.useForm()
    const { url } = useParams();
    const { Panel } = Collapse;
    const isMobile = window.innerWidth <= 810

    useEffect(() => getLinkDetails(propsLinkData), [])

    const getLinkDetails = (propsLinkData) => {
        setIsLoading(false);
        if (Object.keys(propsLinkData).length > 0) {
            if (propsLinkData?.valid) {
                setlinkData(propsLinkData)
                setValidatedAmount(propsLinkData.amount)
                setValidTransaction(true)
            } else {
                const errorMessage = propsLinkData?.error || propsLinkData?.message || propsLinkData?.err_msg
                setlinkData({})
                setValidTransaction(false)
                setError(errorMessage)
            }
        }
    }


    const handlePaymentCall = async () => {
        const autoSubmitForm = (response, apiResponse) => {
            if (!response.transaction_id)
                response = { ...response, ...{ 'transaction_id': apiResponse.ref_id, 'id': null } }
            var form = document.createElement("form");
            form.method = "POST";
            form.action = process.env.REACT_APP_PARTIAL_PAYMENT_URL + "easy-collect/response/" + url + "/";
            let addInputs = (response, parentKey = "") => {
                for (let key in response) {
                    if (response.hasOwnProperty(key)) {
                        let fullKey = parentKey ? `${parentKey}.${key}` : key;
                        if (typeof response[key] === "object" && response[key] !== null) addInputs(response[key], fullKey);
                        else {
                            const input = document.createElement("input");
                            input.type = "hidden";
                            input.name = fullKey;
                            input.value = response[key];
                            form.appendChild(input);
                        }
                    }
                }
            }
            addInputs(response)
            document.body.appendChild(form);
            form.submit();
        }
          setPaymentRequest(true);
          easyCollectAPI
            .call_gateway(url)
            .then((response) => {
              if (response.status === true) {
                if (response.is_hosted) {
                  window.open(response.url + response.data, "_self");
                } else {
                  const easebuzzCheckoutClass = window.EasebuzzCheckout;
                  var easebuzzCheckout = new easebuzzCheckoutClass(
                    response.data,
                    process.env.REACT_APP_ENV,
                  );
                  var options = {
                    access_key: response?.data, // access key received via Initiate Payment
                    theme: "#123456", // color hex
                    onResponse: (checkoutResponse) =>
                      autoSubmitForm(checkoutResponse, response),
                  };
                  easebuzzCheckout.initiatePayment(options);
                }
              } else {
                setPaymentRequest(false);
                message.error(response.error || response.error_desc);
              }
              setPaymentRequest(false);
            })
            .catch((e) => {
              setPaymentRequest(false);
                let err_msg = (e.response.data && e.response.data.error) ||
                  (e.response.data && e.response.data.error_desc)
              message.error(err_msg);
            });
    }

    const GetFirstNameInfo = () => (
        <div className="gap-1" style={isMobile ? { marginLeft: 10 } : { marginBottom: '10px' }}>
            <p className="batch" >  Hi {linkData?.firstname} ,</p>
            <p>Please confirm your personal information</p>
        </div>
    )

    const GetEmailInfo = () => linkData?.email && (
        <div className="gap">
            <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}> Email ID</p>
            <p className="batch text">{linkData?.email}</p>
        </div>
    )


    const GetPhoneInfo = () => linkData?.phone && (
        <div className="gap">
            <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}> Phone</p>
            <p className="batch text">{linkData?.phone}</p>
        </div>
    )

    const GetAdditionalInfo = () => (
        ["udf1", "udf2", "udf3", "udf4", "udf5", "message"].map((key) => {
            return <>
                {
                    linkData[key] &&
                    <div className="" style={{ marginBottom: "7px" }}>
                        <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}>{linkData.easycollect_fields[key]}</p>
                        <p className="batch text">
                            {linkData[key]}
                        </p>
                    </div>
                }
            </>
        })
    )

    const TPVForm = () => {
        const Field = ({ label, _value }) => (
            <div className="gap" key={label} >
                <p className="batch" style={{ color: "#7A8699", fontSize: "14px" }}>{label}</p>
                <p className="batch.text">{_value}</p>
            </div>
        )
        const account_number = linkData?.tpv_details?.bank_account_number
        const PaymentFields = Object.entries(PaymentForm).map(([key, value]) => <Field label={value['label']} _value={value.formatter(linkData['tpv_details'][key])} />)
        return (
            <div className="gap-1">
                <p className="batch">Payment Details</p>
                <p className="batch-2" style={{ marginBottom: "10px" }}>Please confirm your Payment Details</p>
                <Field label={"Amount"} _value={`Rs ${linkData['amount']} only`} />
                {account_number && PaymentFields}
            </div>
        )
    }

    const PaymentConfirmation = () => (
        <div style={{ justifyItems: "center" }}>
            <div style={{ margin: "0px", width: "100px", paddingTop: "82px", marginBottom: '0px' }}>
                <lottie-player src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/Success.json" background="transparent" speed="1" loop={false} autoplay></lottie-player>
            </div>
            <h3>Payment on this link has been done</h3>
        </div>
    )

    const FormDetails = () => {
        if (linkData.payment_made) {
            return <PaymentConfirmation />
        }
        else {
            return (
                <>
                    <Form className="footer_form"
                        form={form} onFinish={handlePaymentCall} >
                        <Form.Item>
                            <span className="auto_collect_footer_section">
                                <Button
                                    loading={isPaymentRequestInitiated}
                                    block className={isMobile ? "pay-button" : "pay"}
                                    style={{ background: "#4E5FF9", color: "#ffff", marginTop: "5px" }}
                                    htmlType="submit"
                                >
                                    <b>
                                        <img style={{ marginRight: "5px" }} alt=""
                                            src="https://ebz-static.s3.ap-south-1.amazonaws.com/partial_payment/download.png" />
                                        Pay Now
                                    </b>
                                </Button>
                            </span>
                        </Form.Item>
                    </Form>
                </>

            )
        }

    }

    const PaymentPage = () => {
        const DisplayErrorDetails = () => {
            if (Object.keys(errorDetails).length !== 0) {
                return (
                    <Col span={24} style={{ margin: "0px", padding: "0px" }}>
                        <Alert style={{ padding: "5px", margin: "0px" }} message={
                            <Collapse defaultActiveKey={["1"]} expandIconPosition="right" accordion ghost >
                                <Panel className="error_panel_class" style={{ margin: "0px", padding: "0px" }}
                                    header={errorDetails.error} key="1">
                                    <div>
                                        {/* <span><b>Transaction ID :</b> {errorDetails.mandate_transaction_id}</span><br /> */}
                                        {/* <span><b>Mandate status :</b> {errorDetails.mandate_status}</span> */}
                                    </div>
                                </Panel>
                            </Collapse>
                        } />
                    </Col>
                )
            }
            return null
        }
        const CollapseDescriptionPanel = () => (
            <Collapse ghost className="collapse-mobile" defaultActiveKey={["1"]} expandIconPosition="right" accordion >
                <Panel className="easycollect-mobile-panel" header={GetFirstNameInfo()} key="1">
                    <GetEmailInfo />
                    <GetPhoneInfo />
                    <GetAdditionalInfo />
                </Panel>
            </Collapse>
        )
        const DescriptionPanel = () => (
            <>
                <GetFirstNameInfo />
                <GetEmailInfo />
                <GetPhoneInfo />
                <GetAdditionalInfo />
            </>
        )

        if (Object.keys(linkData).length !== 0 && valid_transaction) {
            const is_mobile_mapping = {
                true: {
                    'main_section': "mobile-main-section",
                    'card_class': "mobile-wrapper",
                    'descriptionComponents': CollapseDescriptionPanel,
                    "isDeviderHidden": true,
                    'support_class': "support-mobile",
                    'powered_by_class': "centered-logo"
                },
                false: {
                    'main_section': "main-section",
                    'card_class': "easycollect-response-card",
                    'descriptionComponents': DescriptionPanel,
                    "isDeviderHidden": false,
                    'support_class': "support-desktop",
                    'powered_by_class': "powered-by-easebuzz"
                }
            }
            const MappedClass = is_mobile_mapping[isMobile]
            return (
                <>
                    <div className={MappedClass['main_section']}>
                        <Card variant="borderless" cover={<HeaderComponent logo={linkData.m_logo} name={linkData.m_name} />} className={MappedClass['card_class']}>
                            <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                                <Row>
                                    <DisplayErrorDetails />
                                    <Col span={24}><p style={{ fontSize: "20px", marginTop: '10px' }}>{linkData.is_auto_debit_link ? 'Mandate authorization Request' : null}</p></Col>
                                </Row>
                                <Row>
                                    <Col span={11} lg={11} xs={24}>{MappedClass['descriptionComponents']()}</Col>
                                    <Divider type="vertical" className="divider-line" style={{ height: "42vh" }} hidden={MappedClass['isDeviderHidden']} />
                                    <Col className="payment_details_section"
                                        span={11} lg={11} xs={24}>
                                        <TPVForm />
                                        <FormDetails />
                                    </Col>
                                </Row>
                                <Row >
                                    <Col xl={{ span: 16 }} lg={{ span: 16 }} xs={{ span: 24 }} className={MappedClass['support_class']}>
                                        <p style={{ color: "#7A8699" }}> For any queries, please contact us at <a href="mailto:support@easebuzz.in">support@easebuzz.in</a></p>
                                    </Col>
                                    <Col xl={{ span: 8 }} lg={{ span: 8 }} xs={{ span: 24 }} className={MappedClass['powered_by_class']}>
                                        <img alt="" src="https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Group+3097poweredbyeasebuzz.svg" />
                                    </Col>
                                </Row>
                            </Skeleton>
                        </Card>
                    </div>
                </>
            )
        }
        else if (error) {
            return <SmartPayError status={400} title={error} />
        }
        return <SmartPayError />
    }

    if (propsLinkData.version === "v2") {
        let layoutConfig = propsLinkData?.display_config &&
            Object.keys(propsLinkData.display_config).length
                ? propsLinkData.display_config
                : BASE_CONFIG;
        return linkData.payment_made ? <PaymentPage /> : <RemotePrePayment config={layoutConfig} data={linkData} />
    }
    return <PaymentPage />
}

const EasyCollectResponse = (props) => {
    const { propsLinkData } = props
    const [data, setData] = useState({})
    const [error, setError] = useState(null)
    const { url, txn_id } = useParams();
    const [isLoading, setIsLoading] = useState(true)
    const isMobile = window.innerWidth <= 810

    useEffect(() => getLinkResponse(), [])

    const getLinkResponse = async () => {
        setIsLoading(true);
        if (!txn_id || txn_id === "failure") {
            setIsLoading(false);
            setError("Unable to retrieve response")
        }
        else {
            if (Object.keys(propsLinkData).length > 0) {
                // data came from wrapper component
                if (propsLinkData?.data) {
                    if (propsLinkData.status) setData(propsLinkData.data)
                    else setError(propsLinkData?.error)
                }
                else setError("Link not found")
                setIsLoading(false)
            } else {
                await easyCollectAPI.get_response(url, txn_id)
                    .then((response) => {
                        if (response.status) setData(response.data)
                        else setError(response?.error)
                    })
                    .catch((error) => setError("Link not found"))
                    .finally(() => setIsLoading(false))
            }
        }
    }

    const PaymentInfo = () => {
        const normal_mapping = {
            true: { title: "Payment Successful", status: "success" },
            false: { title: "Payment Failed", status: "error" }
        }
        let fields = {}
        let resultProps = {}
        if (data && !error) {
            resultProps = normal_mapping[data?.payment_made];
            if (resultProps && data?.is_auth_capture_link && data?.payment_details?.status === "pending")
                resultProps.title = "Transaction Authorized"
            fields = Object.entries(PaymentInfoFields).map(([key, value]) => {
                const valuemapper = value?.valuemapper || {};
                const value_key = value.key
                let value_ = ''
                if (value_key && Object.keys(data).includes(value_key)) value_ = data[value_key][key]
                else value_ = data[key]
                value_ = valuemapper[value_] ? valuemapper[value_] : value_;
                return (
                    <Descriptions.Item key={key} style={{ marginBottom: "7px" }} label={value.label} span='filled'>
                        {value_}
                    </Descriptions.Item>
                )
            })
        }
        else {
            resultProps = normal_mapping[false];
            resultProps.title = "Unable to verify the payment status for the link"
            fields = (
                <>
                    <Descriptions.Item key="message" style={{ marginBottom: "7px" }} label="Error" span='filled'>
                        No response recieved from the intermdediate system.
                        <br />
                        The potential causes can be
                        <ol type="1">
                            <li>Invalid response from the intermdediate system</li>
                            <li>Delay in response from the bank's end</li>
                            <li>Issue with the current flow with the intermdediate system</li>
                            <li>Incorrect/Malformed reference ID provided in the response</li>
                        </ol>
                    </Descriptions.Item>
                    <Descriptions.Item key="retry" style={{ marginBottom: "7px" }} label="Retry" span="filled">
                        Click <a href={process.env.REACT_APP_EASYCOLLECT_URL + url}>here</a> to retry
                    </Descriptions.Item>
                </>
            )

        }
        return (
            <div className="payment-info">
                <Result style={{ textAlign: "center" }} {...resultProps} />
                <Descriptions bordered>{fields}</Descriptions>
            </div>
        )
    }

    const PaymentResponse = () => {
        if (data) {
            const mobile_class_mapping = {
                true: {
                    'main_div_class_name': "mobile-main-section",
                    'card_class_name': "mobile-wrapper",
                    'support_class_name': 'support-mobile',
                    'powered_class_name': 'centered-logo',
                },
                false: {
                    'main_div_class_name': "main-section",
                    'card_class_name': 'easycollect-response-card',
                    'support_class_name': 'support-desktop',
                    'powered_class_name': "powered-by-easebuzz"
                }
            }
            const mapped_class_names = mobile_class_mapping[isMobile]
            return (
                <div className={mapped_class_names['main_div_class_name']}>
                    <Card variant="borderless" cover={<HeaderComponent logo={data.m_logo} name={data.m_name} />} className={mapped_class_names['card_class_name']}>
                        <Skeleton loading={isLoading} paragraph={{ rows: 20 }}>
                            <Row className="easycollect-response-card-col-1">
                                <Col span={24}><PaymentInfo /></Col>
                            </Row>
                            <Row className="easycollect-response-card-col-2">
                                <Col xl={{ span: 16 }} lg={{ span: 16 }} xs={{ span: 24 }} className={mapped_class_names['support_class_name']}>
                                    <p style={{ color: "#7A8699" }}>
                                        For any queries, please contact us at <a href="mailto:support@easebuzz.in">support@easebuzz.in</a>
                                    </p>
                                </Col>
                                <Col xl={{ span: 8 }} lg={{ span: 8 }} xs={{ span: 24 }} className={mapped_class_names['powered_class_name']}>
                                    <img alt=""
                                        src="https://ebz-static.s3.ap-south-1.amazonaws.com/logo/Group+3097poweredbyeasebuzz.svg" />
                                </Col>
                            </Row>
                        </Skeleton>
                    </Card>
                </div>
            )
        }
        if (error)
            return (<SmartPayError status={400} title={'Not Found'} />)
    }

    if (data.version === "v2") {
        let layoutConfig = propsLinkData?.data?.display_config &&
            Object.keys(propsLinkData.data.display_config).length
                ? propsLinkData.data.display_config
                : BASE_CONFIG;
        return <RemotePostPayment config={layoutConfig} data={propsLinkData} />
    }
    return <PaymentResponse />

}
export { EasyCollect, EasyCollectResponse };